import { cn } from '@/lib/utils'

interface PeriodPillsProps<T extends string> {
  options: ReadonlyArray<{ value: T; label: string }>
  value: T | undefined
  onChange: (value: T) => void
}

export function PeriodPills<T extends string>({ options, value, onChange }: PeriodPillsProps<T>) {
  return (
    <div className="overflow-x-auto no-scrollbar">
      <div className="inline-flex items-center gap-1.5">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={cn(
              'px-3 py-1 min-h-11 sm:min-h-7.5 text-xs font-medium rounded-md',
              'transition-all duration-150 ease-in-out',
              'focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary/12',
              value === option.value
                ? 'bg-primary text-primary-foreground shadow-[0_1px_2px_rgba(16,185,129,0.3)]'
                : 'bg-muted text-muted-foreground hover:text-foreground motion-safe:hover:-translate-y-px hover:shadow-[0_2px_4px_rgba(0,0,0,0.08)]'
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  )
}
